import config from '../config.js'

let fxRates
let loadingRates = false

async function loadRates () {
  loadingRates = true
  return new Promise((resolve, reject) => {
    if (config.dev) console.log('loading rates...')
    const now = new Date()
    // Cache-bust every hour (the API sets http headers to cache for 365 days)
    // var requestURL = `http://data.fixer.io/api/latest?access_key=091f1f06b306b687f7d7d6c5a0e1a7ae&format=1&base=EUR`;
    var requestURL = `/rates.json?v=${now.getFullYear()}-${now.getMonth()}-${now.getDate()}-${now.getHours()}`;
    var request = new XMLHttpRequest();
    request.open('GET', requestURL);
    request.responseType = 'json';

    request.onerror = (msg) => {
      if (config.dev) console.log('request error: ', msg)
      loadingRates = false
      reject(msg)
    }

    request.onload = () => {
      var response = request.response;
      fxRates = processRates(response.rates)
      loadingRates = false
      if (config.dev) console.log('Loaded exchange rates')
      resolve(fxRates)
    }

    request.send()
  })
}

// convert from EUR base to BTC base
function processRates(rates) {
  const btcRates = {}
  const eurBtc = Number.parseFloat(rates["BTC"]) / Number.parseFloat(rates["EUR"])
  Object.keys(rates).forEach(code => {
    btcRates[code] = Number.parseFloat(rates[code]) / eurBtc
  })
  if (config.dev) console.log(btcRates)
  return btcRates
}

async function awaitRates () {
  if (fxRates) {
    return Promise.resolve(fxRates)
  } else {
      return new Promise((resolve, reject) => {
      setTimeout(() => { resolve(awaitRates()) }, 100)
    })
  }
}

export async function getFxRates () {
  if (fxRates) return fxRates
  else if (!loadingRates) return loadRates()
  else return awaitRates()
}

//
// export const fxRates = {
//   USD: 33703.34,
//   GBP: 24371.18,
//   EUR: 28771.54,
//   CNY: 235240.95,
//   JPY: 3823604.75,
//   INR: 2529779.20,
//   RUB: 2713583.52,
//   KRW: 39050038,
//   CHF: 31782.80,
//   BRL: 185916.09,
//   MXN: 709774.62,
//   CAD: 42961.55,
//   AUD: 46282.46,
//   HKD: 278699.98,
//   SAR: 134659.58,
//   TRY: 307280.32,
//   SGD: 47502.98,
//   ZAR: 494602.10,
//   SEK: 298337.79,
//   AED: 132861.82,
//   AFN: 2828335.6,
//   ALL: 3649708.5,
//   AMD: 18814918.64,
//   ANG: 64556.59,
//   AOA: 23223237.81,
//   ARS: 3418216.48,
//   AZN: 61399.46,
//   BAM: 57969.25,
//   BBD: 71402.05,
//   BDT: 3025881.18,
//   BGN: 57262.61,
//   BHD: 13370.26,
//   BIF: 70112883,
//   BMD: 35546.58,
//   BOB: 244212.52,
//   BWP: 374604.94,
//   BYN: 88774.03,
//   CLP: 26568763,
//   COP: 136339118.17,
//   CRC: 21279167.96,
//   CUP: 887195.12,
//   CVE: 3328322.28,
//   CZK: 761766.81,
//   DJF: 6511131.4,
//   DKK: 223622.36,
//   DOP: 2090647.00,
//   DZD: 4897477.55,
//   EGP: 576691.29,
//   ERN: 551229.43,
//   ETB: 1598624.72,
//   FJD: 75136.73,
//   GEL: 120375.61,
//   GHS: 214114.95,
//   GMD: 1885839.82,
//   GNF: 360870300,
//   GTQ: 285933.33,
//   GYD: 7774734.92,
//   HNL: 893629.11,
//   HRK: 228251.08,
//   HTG: 3398081.20,
//   HUF: 10656925.81,
//   IDR: 535930631.12,
//   ILS: 122038.20,
//   IQD: 54834022,
//   IRR: 1579049500,
//   ISK: 4526693,
//   JMD: 5577702.36,
//   JOD: 26596.044,
//   KES: 3984874.93,
//   KGS: 3098774.52,
//   KHR: 150574774.80,
//   KMF: 14866411,
//   KPW: 33097988,
//   KWD: 11059.95,
//   KZT: 15722086.72,
//   LAK: 347040410,
//   LBP: 55583209,
//   LKR: 7268303.58,
//   LRD: 6326076.62,
//   LSL: 504347.42,
//   LYD: 163626.244,
//   MAD: 327303.50,
//   MDL: 637572.64,
//   MGA: 136053600,
//   MKD: 1826531.90,
//   MMK: 59743174,
//   MNT: 103626676.15,
//   MRU: 1310872.63,
//   MUR: 1477387.08,
//   MVR: 556045.85,
//   MWK: 28529622.86,
//   MYR: 148956.85,
//   MZN: 2205341.10,
//   NAD: 496299.13,
//   NGN: 14914688.21,
//   NIO: 1265578.27,
//   NOK: 299556.34,
//   NPR: 4222502.99,
//   NZD: 49699.43,
//   OMR: 13865.499,
//   PEN: 139575.81,
//   PGK: 126797.01,
//   PHP: 1724382.91,
//   PKR: 5605766.96,
//   PLN: 131833.03,
//   PYG: 244426110,
//   QAR: 131547.09,
//   RON: 145433.29,
//   RSD: 3477974.6,
//   RWF: 35769613,
//   SBD: 287431.39,
//   SCR: 590252.03,
//   SDG: 15247192.25,
//   SLL: 367508740,
//   SOS: 20719251,
//   SRD: 508589.07,
//   STN: 719879.91,
//   SYP: 45160886,
//   THB: 1120207.79,
//   TJS: 414214.01,
//   TMT: 127237.67,
//   TND: 98168.310,
//   TOP: 80434.92,
//   TTD: 246504.94,
//   TWD: 1006408.00,
//   TZS: 84484596.28,
//   UAH: 1000937.96,
//   UGX: 129237480,
//   UYU: 1591632.62,
//   UZS: 383287556.08,
//   VES: 112848028947.96,
//   VND: 837373290,
//   VUV: 3924418.8,
//   WST: 91392.31,
//   YER: 9066303,
//   ZMW: 817623.60,
// }
